<template>
  <div class="page">
    <query-form label-width="70px">
      <template v-slot:formitem>
        <query-form-item :label="$t('common.brand')">
          <brand-select v-model="queryForm.brandIds" multiple collapse-tags clearable :data="brandList" label-prop="brandName"></brand-select>
        </query-form-item>
        <query-form-item :label="$t('common.designerId')">
          <el-input clearable v-model="queryForm.designerId"></el-input>
        </query-form-item>
        <query-form-item :label="$t('common.color')">
          <el-input clearable v-model="queryForm.colorCode"></el-input>
        </query-form-item>
        <query-form-item :label="$t('common.season')" label-width="100px">
          <el-select v-model="queryForm.seasonCodes" multiple collapse-tags clearable style="width: 100%">
            <el-option v-for="item in seasonList" :label="item" :value="item" :key="item"></el-option>
          </el-select>
        </query-form-item>
        <query-form-item :label="$t('common.category')">
          <el-cascader
            v-model="queryForm.categoryIds"
            clearable
            :props="optionProps"
            collapse-tags
            :options="categoryList"
            style="width: 100%"
          ></el-cascader>
        </query-form-item>
      </template>
      <template>
        <el-button class="mb10" type="primary" @click="search">{{ $t('common.search') }}</el-button>
        <el-button class="mb20" type="info" @click="reset">{{ $t('common.reset') }}</el-button>
      </template>
    </query-form>

    <el-alert :title="$t('product.poolTip')" type="warning"></el-alert>

    <el-table class="spacing-table mt20" :data="tableData" v-loading="loading">
      <el-table-column label="" width="80" class-name="nopadding">
        <template slot-scope="scope">
          <list-img :img="scope.row.spuImage" :width="40"></list-img>
        </template>
      </el-table-column>
      <el-table-column prop="designerId" :label="$t('common.productInfo')">
        <template slot-scope="scope">
          <p class="keep-space">
            <span class="label">{{ $t('common.designerId') }}</span
            >: {{ scope.row.designerId }}
          </p>
          <p class="keep-space">
            <span class="label">{{ $t('common.color') }}</span
            >: {{ scope.row.colorCode }}
          </p>
        </template>
      </el-table-column>
      <el-table-column prop="seasonCode" :label="$t('common.season')">
        <template slot-scope="scope">{{ scope.row.seasonCode }}</template>
      </el-table-column>
      <el-table-column prop="brandName" :label="$t('common.brand')"></el-table-column>
      <el-table-column prop="categoryName" :label="$t('common.category')"></el-table-column>
      <el-table-column prop="retailPriceIncludedTax" :label="`${$t('common.retailPrice')}/${originalPriceUnit}`"></el-table-column>
      <el-table-column prop="hasCreate"  :label="$t('product.hasBeenCreated')">
        <template slot-scope="scope">
          {{ scope.row.hasCreate ? $t('common.yes') : $t('common.no') }}
        </template>
      </el-table-column>
      <el-table-column width="150" :label="$t('common.operation')">
        <template slot-scope="scope">
          <el-button type="primary" v-if="!scope.row.hasCreate" @click="createItem(scope.row)">{{ $t('product.copyCreate') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100, 200]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <el-dialog :title="$t('product.copyCreate')" :visible.sync="dialogVisible" width="800px">
      <base-info>
        <base-info-item :label="$t('common.designerId')">{{ detail.designerId }}</base-info-item>
        <base-info-item :label="$t('common.color')">{{ detail.colorCode }}</base-info-item>
        <base-info-item :label="$t('common.season')">{{ detail.seasonCode }}</base-info-item>
        <base-info-item :label="$t('common.brand')">{{ detail.brandName }}</base-info-item>
      </base-info>
      <table class="edittable" v-loading="loadingSize">
        <tr>
          <th>{{ $t('product.sizeStandard') }}</th>
          <th>{{ $t('common.size') }}</th>
          <th>{{ $t('common.retailPrice') }}/{{ originalPriceUnit }}</th>
          <th width="120">
            <p>{{ $t('common.supplyPrice') }}/{{ originalPriceUnit }}</p>
            <el-input type="number" v-model.number="batch.supplyPrice" :maxlength="9" size="mini" />
          </th>
          <th width="130">
            <p>{{ $t('common.stock') }}</p>
            <el-input type="number" v-model.number="batch.stock" :maxlength="5" size="mini" />
          </th>
          <th width="50">
            <p>&nbsp;</p>
            <el-button size="mini" type="primary" plain @click="batchSetting">{{ $t('product.batchSet') }}</el-button>
          </th>
        </tr>
        <tr v-for="(item, index) in SKUList" :key="index">
          <td>{{ item.countrySize }}</td>
          <td>{{ item.size }}</td>
          <td>{{ item.retailPrice }}</td>
          <td>
            <el-input-number
              size="small"
              style="width: 100%"
              v-model.number="item.supplyPrice"
              :precision="2"
              :step="1"
              :min="0"
              :max="999999999.99"
              :controls="false"
            ></el-input-number>
          </td>
          <td>
            <el-input-number
              size="small"
              style="width: 100%"
              v-model.number="item.stock"
              :step="1"
              :min="0"
              :max="99999999"
            ></el-input-number>
          </td>
          <td></td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="submit" :loading="submitLoading">{{ $t('common.ok') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  getProductPoolConfig,
  getProductPoolSPUList,
  getProductPoolStandardSize,
  createProductFromProductPool,
} from '../../api/product';
import ListImg from '../../components/ListImg';
import BrandSelect from '../../components/BrandSelect';

export default {
  name: 'Canceled',
  components: {
    ListImg,
    BrandSelect,
  },
  data() {
    return {
      loading: false,
      brandList: [],
      seasonList: [],
      categoryList: [],
      optionProps: {
        value: 'categoryId',
        children: 'children',
        label: 'name',
        expandTrigger: 'hover',
        emitPath: false,
        checkStrictly: false,
        multiple: true,
      },
      queryForm: {
        brandIds: [],
        seasonCodes: [],
        categoryIds: [],
        designerId: null,
        colorCode: null,
        pageNo: 1,
        pageSize: 25,
      },
      total: 0,
      tableData: [],
      dialogVisible: false,
      loadingSize: false,
      detail: {},
      SKUList: [],
      batch: {
        supplyPrice: null,
        stock: null,
      },
      submitLoading: false,
    };
  },
  computed: mapState({
    // 店铺币种Code
    originalPriceUnit: (state) => state.userinfo.originalPriceUnit,
  }),
  created() {
    getProductPoolConfig().then((res) => {
      this.brandList = res.data.brandInfoList;
      this.seasonList = res.data.seasonCodeList;
      this.categoryList = res.data.categoryInfoList;
    });
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.brandIds = [];
      this.queryForm.seasonCodes = [];
      this.queryForm.categoryIds = [];
      this.queryForm.designerId = null;
      this.queryForm.colorCode = null;
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      this.loading = true;
      getProductPoolSPUList({
        ...this.queryForm,
        brandIds: this.queryForm.brandIds.join(','),
        seasonCodes: this.queryForm.seasonCodes.join(','),
        categoryIds: this.queryForm.categoryIds.join(','),
      }).then((res) => {
        this.tableData = res.list;
        this.total = res.total;
        this.loading = false;
      });
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    createItem(row) {
      this.getSizeList(row);
      this.detail = row;
      this.batch.supplyPrice = null;
      this.batch.stock = null;
      this.submitLoading = false;
      this.dialogVisible = true;
    },
    getSizeList(row) {
      this.loadingSize = true;
      getProductPoolStandardSize({ spuId: row.spuId }).then((res) => {
        if (res.success && res.data) {
          this.SKUList = res.data.portalSizeVos.map((item) => ({
            countrySize: item.countrySizeTypeValue,
            size: item.size,
            retailPrice: row.retailPriceIncludedTax,
            supplyPrice: null,
            stock: 0,
          }));
        } else {
          this.$message.error(res.message || this.$t('error.systemerror'));
        }
        this.loadingSize = false;
      });
    },
    batchSetting() {
      const { supplyPrice, stock } = this.batch;

      this.SKUList.forEach((item) => {
        if (supplyPrice) {
          item.supplyPrice = supplyPrice;
        }
        if (stock) {
          item.stock = stock;
        }
      });
    },
    submit() {
      if (this.SKUList.some((item) => !item.supplyPrice || (!item.stock && item.stock !== 0))) {
        this.$message.error(this.$t('product.pleaseSetSupplyPriceAndStock'));
        return;
      }
      if (this.submitLoading) {
        return;
      }
      this.submitLoading = true;
      createProductFromProductPool({
        spuInfo: {
          spuId: this.detail.spuId,
          designerId: this.detail.designerId,
          colorCode: this.detail.colorCode,
          seasonCode: this.detail.seasonCode,
          brandId: this.detail.brandId,
          categoryId: this.detail.categoryId,
        },
        boutiqueSkuList: this.SKUList,
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.dialogVisible = false;
          this.getTableData();
        } else {
          this.$message.error(res.message || this.$t('error.systemerror'));
        }
        this.submitLoading = false;
      }).catch(() => {
        this.submitLoading = false;
        this.$message.error(this.$t('error.systemerror'));
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.label {
  margin-bottom: 0;
  font-size: 12px;
  font-weight: 300;
  line-height: 14px;
}
.value {
  margin: 0;

  & + .label {
    margin-top: 10px;
  }
}
.edittable {
  width: 100%;
  th {
    padding: 0 10px 10px;
    text-align: left;
    border-bottom: 1px solid #ebeef5;
  }
  td {
    padding: 5px 10px;
    border-bottom: 1px solid #ebeef5;
  }
}
</style>
